import { DEFAULT_CERT_ICON_NAME } from "@utils/certificateIcons";
import { ProductCategory } from "@utils/constants";
import { VDBIcons } from "@utils/VDBIcons";

const requestShapeMap = {
  Round: { name: VDBIcons.ROUND },
  Oval: { name: VDBIcons.OVAL },
  Pear: { name: VDBIcons.PEAR },
  CushMod: { name: VDBIcons.CUSH_MOD }, // Need Check
  CushBrill: { name: VDBIcons.CUSH_BRILL },
  Emerald: { name: VDBIcons.EMERALD },
  Radiant: { name: VDBIcons.RADIANT },
  Princess: { name: VDBIcons.PRINCESS },
  Asscher: { name: VDBIcons.ASSCHER },
  Square: { name: VDBIcons.SQUARE },
  Marquise: { name: VDBIcons.MARQUISE },
  Heart: { name: VDBIcons.HEART },
  Trilliant: { name: VDBIcons.TRILLIANT },
  EuroCut: { name: VDBIcons.EURO_CUT }, // Need Check
  OldMiner: { name: VDBIcons.OLD_MINER }, // Need Check
  Briolette: { name: VDBIcons.BRIOLETTE },
  RoseCut: { name: VDBIcons.ROSE_CUT }, // Need Check
  Lozenge: { name: VDBIcons.LOZENGE },
  Baguette: { name: VDBIcons.BAGUETTE },
  TapBaguette: { name: VDBIcons.TAPERED_BAGUETTE }, // Need Check
  HalfMoon: { name: VDBIcons.HALF_MOON }, // Need Check
  Flanders: { name: VDBIcons.FLANDERS },
  Trapezoid: { name: VDBIcons.TRAPEZOID },
  Bullets: { name: VDBIcons.BULLET },
  Kite: { name: VDBIcons.KITE },
  Shield: { name: VDBIcons.SHIELD },
  Star: { name: VDBIcons.STAR },
  Pentagonal: { name: VDBIcons.PENTAGONAL },
  Hexagonal: { name: VDBIcons.HEXAGONAL },
  Octagonal: { name: VDBIcons.OCTAGONAL },
  Other: { name: VDBIcons.IMAGE },
  Cushion: { name: VDBIcons.CUSH_MOD },
  "cushion modified brilliant": { name: VDBIcons.CUSH_MOD },
  "Cushion Square": { name: VDBIcons.CUSH_SQUARE },
  cushion: { name: VDBIcons.CUSH_BRILL },
  "cush brill": { name: VDBIcons.CUSH_BRILL },
  "cushion brilliant": { name: VDBIcons.CUSH_BRILL },
  "Cushion Long": { name: VDBIcons.CUSH_LONG },
  "radiant-r": { name: VDBIcons.RADIANT },
  "radiant-s": { name: VDBIcons.RADIANT },
  "square emerald": { name: VDBIcons.ASSCHER },
  triangle: { name: VDBIcons.TRILLIANT },
  "old fancy": { name: VDBIcons.EURO_CUT }, // Need Check
  "carre square baguette": { name: VDBIcons.BAGUETTE },
  "baguette a": { name: VDBIcons.BAGUETTE },
  taper: { name: VDBIcons.TAPERED_BAGUETTE }, // Need Check
  "taper a": { name: VDBIcons.TAPERED_BAGUETTE }, // Need Check
  "taper b": { name: VDBIcons.TAPERED_BAGUETTE }, // Need Check
  "hmoon b": { name: VDBIcons.HALF_MOON }, // Need Check
  "hmoon step": { name: VDBIcons.HALF_MOON }, // Need Check
  "trapezoid step": { name: VDBIcons.TRAPEZOID },
  "trapezoid brilliant": { name: VDBIcons.TRAPEZOID },
  "trapz b": { name: VDBIcons.TRAPEZOID },
  "trapz s": { name: VDBIcons.TRAPEZOID },
  bullet: { name: VDBIcons.BULLET },
  "tapered bullet": { name: VDBIcons.BULLET },
  "Tapered Bullet": { name: VDBIcons.BULLET },
  "Half Moon": { name: VDBIcons.HALF_MOON },
  "Tapered Baguette": { name: VDBIcons.TAPERED_BAGUETTE },
  "Rose Cut": { name: VDBIcons.ROSE_CUT },
  "Old Miner": { name: VDBIcons.OLD_MINER },
  "Cushion Modified": { name: VDBIcons.CUSH_MOD },
  Eurocut: { name: VDBIcons.EURO_CUT },
  video: { name: VDBIcons.VIDEO_UNAVAILABLE },
  pdf: { name: DEFAULT_CERT_ICON_NAME },
};

export function convertShapeType(shapeName: any) {
  return {
    icon_name: requestShapeMap[shapeName as keyof typeof requestShapeMap]?.name,
  };
}

export const getShapeValue = (itemDetail: any) => {
  return itemDetail?.type !== ProductCategory.JEWELRY &&
    itemDetail?.type !== ProductCategory.LABGROWN_JEWELRY
    ? itemDetail?.shape
    : undefined;
};
